import { useAuth } from 'context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import { UserRole } from 'shared/constants';

export const ClientGuard = () => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user?.roles.includes(UserRole.CLIENT)) {
    return <Navigate to="/sitter-dashboard" replace />;
  }

  return <Outlet />;
};
